import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import { axiosAuth } from "@/plugins/axios";

import { encryptData, decryptData } from "@/plugins/crypto"; // tus helpers
import type { AuthData } from "@/types/auth.context"; // tu tipo de auth

export function setupAuthInterceptor(instance: AxiosInstance) {
  instance.interceptors.request.use(
    async (
      request: InternalAxiosRequestConfig
    ): Promise<InternalAxiosRequestConfig> => {
      const stored = localStorage.getItem("auth");
      if (!stored) return request;

      const auth: AuthData = decryptData(stored);
      if (!auth?.access_token) return request;

      const decoded: any = jwtDecode(auth.access_token);
      const isExpired = dayjs.unix(decoded.exp).diff(dayjs()) < 1;

      if (!isExpired) {
        request.headers.set("Authorization", `Bearer ${auth.access_token}`);
        return request;
      }

      try {
        const { data } = await axiosAuth.post(`/auth/refresh`, null, {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        });

        const newAuth: AuthData = { ...auth, access_token: data.access_token };
        localStorage.setItem("auth", encryptData(newAuth));

        request.headers.set("Authorization", `Bearer ${data.access_token}`);
      } catch (error) {
        localStorage.removeItem("auth");
        window.dispatchEvent(new Event("auth:expired"));
      }

      return request;
    },
    (error) => Promise.reject(error)
  );
}
